const ProfitabilityChart = require('./ProfitabilityChart');

module.exports = ProfitabilityChart;
